import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M616 0c13.3 0 24 10.75 24 24s-10.7 24-24 24H24C10.75 48 0 37.25 0 24S10.75 0 24 0zm0 464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.25 0-24-10.7-24-24s10.75-24 24-24z",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M83.2 160c0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64-64-28.7-64-64M192 256c12.2 0 23.7 3.4 33.4 9.4-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.67 0-32-14.3-32-32 0-35.3 28.65-64 64-64zm384 96h-82.4c-10.4-40.1-40.5-72.6-77.7-87.4 9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64 0 17.7-14.3 32-32 32m-110.4 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32 0-11.2 1.9-22 5.5-32 10.5-29.7 35.2-52.8 66-60.9 7-2 16-3.1 24.5-3.1h96c7.4 0 14.7.8 21.6 2.4 32.1 7.4 58.1 30.9 68.9 61.6 3.6 10 5.5 20.8 5.5 32m-30.4-224c0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64-64-28.7-64-64m-33.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80 35.8-80 80-80 80 35.8 80 80",
      style: {"fill":"var(--fa-secondary-color, currentColor)","opacity":"var(--fa-secondary-opacity, 0.4)"}
    }, null, -1)
  ])))
}
export default { render: render }